<template>
  <div class="user-collection">
    <el-dialog
      title=""
      :fullscreen="true"
      :show-close="false"
      :visible.sync="dialogFormVisible"
    >
      <el-tabs
        v-model="activeName"
        type="card"
        @tab-click="handleClick"
        v-if="dialogFormVisible"
      >
        <el-tab-pane label="我收藏的单品" name="first" class="firstLable">
          <div>
            <div ref="headsection" class="head-section">
              <div ref="headtap">
                <div class="clearfloat" />
                <div>
                  <el-form ref="form" :model="form" :inline="true">
                    <el-row>
                      <el-col :span="24">
                        <el-form-item prop="productLine">
                          <el-select
                            v-model="form.productLine"
                            filterable
                            clearable
                            placeholder="点选产品线"
                            :loading="loading"
                            value-key="lineId"
                            @change="onProdLineChange"
                            @clear="clearLine"
                          >
                            <el-option
                              v-for="item in allProdLines"
                              :key="item.lineId"
                              :label="item.lineName"
                              :value="item"
                            />
                          </el-select>
                        </el-form-item>
                        <el-form-item>&nbsp;</el-form-item>
                        <el-form-item prop="productCategories">
                          <el-select
                            v-model="form.productCategories"
                            filterable
                            clearable
                            reserve-keyword
                            placeholder="点选产品大类"
                            :loading="loading"
                            value-key="categoryId"
                            @change="onProductCategoriesChange"
                            @clear="clearCategories"
                          >
                            <el-option
                              v-for="item in allProductCategories"
                              :key="item.categoryId"
                              :label="item.categoryName"
                              :value="item"
                            >
                              <span style="font-weight: bold">{{ '[产品大类]：' +item.categoryName }}</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ '[产品线]：'
                                + item.lineName }}
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item>&nbsp;</el-form-item>
                        <el-form-item prop="productSeries">
                          <el-select
                            v-model="form.productSeries"
                            filterable
                            clearable
                            reserve-keyword
                            placeholder="点选产品系列"
                            :loading="loading"
                            value-key="seriesId"
                            @change="seachForm"
                          >
                            <el-option
                              v-for="item in allProductSeries"
                              :key="item.seriesId"
                              :label="item.seriesName"
                              :value="item"
                            >
                              <span style="font-weight: bold">
                                {{ '[产品系列]：' +item.seriesName }}
                              </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              {{ '[产品大类]：' +item.categoryName }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              {{ '[产品线]：' + item.lineName }}
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item>&nbsp;</el-form-item>
                        <el-form-item prop="lineProperty">
                          <el-cascader
                            v-model="form.lineProperty"
                            :options="allLinePropertyMap"
                            :show-all-levels="false"
                            clearable
                            :filterable="false"
                            expand-trigger="hover"
                            placeholder="根据产品线加载分类"
                            :props="{value: `propertyCode`,label: `propertyName`,children: `children`}"
                            @change="seachForm"
                          />
                        </el-form-item>
                        <el-form-item>&nbsp;</el-form-item>
                        <el-form-item prop="keys">
                          <el-input
                            v-model="form.keys"
                            placeholder="通过产品型号、描述搜索"
                            @keyup.enter.native="seachForm"
                          />
                        </el-form-item>
                        <el-form-item>
                          <el-button type="primary" @click="seachForm()">搜索</el-button>
                          <el-button @click="resetForm('form')">重置</el-button>
                          <el-button @click="goback">关闭</el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="17">
                        <el-form-item prop="productStatus">
                          <el-checkbox v-model="form.productStatus" true-label="0" false-label="" @change="seachForm">
                            隐藏退市
                          </el-checkbox>
                        </el-form-item>
                        <el-form-item prop="isSpecialControlled">
                          <el-checkbox
                            v-model="form.isSpecialControlled"
                            true-label="true"
                            false-label="false"
                            @change="seachForm"
                          >
                            隐藏专供&nbsp;
                          </el-checkbox>
                        </el-form-item>
                        <el-form-item prop="isProductPackage">
                          <el-checkbox
                            v-model="form.isProductPackage"
                            true-label="true"
                            false-label="false"
                            @change="seachForm"
                          >
                            隐藏组合包 &nbsp;
                          </el-checkbox>
                        </el-form-item>
                        <el-form-item prop="showOpticalModule">
                          <el-checkbox
                            v-model="form.showOpticalModule"
                            true-label="true"
                            false-label="false"
                            @change="seachForm"
                          >
                            隐藏光模块&nbsp;
                          </el-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="7" align="right">
                        <el-button
                          type="primary"
                          @click="createProductGroupSubItem"
                        >
                          添加产品至配置组
                        </el-button>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
            <el-table
              :data="ProductInitListVO"
              border
              :stripe="true"
            >
              <el-table-column
                prop="seriesName"
                label="产品系列"
                min-width="9%"
                align="left"
              />
              <el-table-column
                prop="productName"
                label="产品型号"
                min-width="15%"
                align="left"
              >
                <template slot-scope="scope">
                  <ProductNameFormation :scope="scope" />
                </template>
              </el-table-column>
              <el-table-column
                label="产品描述"
                :render-header="foo"
                min-width="20%"
                align="left"
              >
                <template slot-scope="scope">
                  <long-text :text="scope.row.productDesc" :switch-flg="switchFlgP" />
                </template>
              </el-table-column>

              <el-table-column
                prop="productPrice"
                label="价格（元）"
                width="120"
                align="center"
                :formatter="priceFormat"
              />
              <el-table-column
                prop="purchaseQuantity"
                label="数量"
                min-width="8%"
                align="center"
              >
                <template slot-scope="scope">
                  <el-input-number
                    size="mini"
                    controls-position="right"
                    v-model="scope.row.purchaseQuantity"
                    :min="0"
                    :precision="0"
                    :max="scope.row.productConfigInfo !== null &&
                      scope.row.productConfigInfo !== '' ||
                      scope.row.optionalType === 1 &&
                      scope.row.subPropertyName === '主机' ? 1 : 99999"
                    @change="numberChange(scope.$index)"
                    style="width: 110px"
                  />
                </template>
              </el-table-column>
              <el-table-column
                prop="productStatusStr"
                label="状态"
                min-width="4%"
                align="center"
              >
                <template slot-scope="scope">
                  <ProductStatusFomation :scope="scope.row" />
                </template>
              </el-table-column>
              <el-table-column
                prop="productType"
                label="周期、下单后准备时间"
                min-width="6%"
                align="center"
              >
                <template slot-scope="scope">
                  <ProductTypeFormation :scope="scope.row" />
                </template>
              </el-table-column>
              <el-table-column
                prop="productPscType"
                label="服务分类"
                min-width="3%"
                align="center"
              />
              <el-table-column
                label="特殊说明"
                :render-header="foo"
                min-width="20%"
                align="left"
              >
                <template slot-scope="scope">
                  <long-text :text="notesTextFormat(scope.row.notes,scope.row.supplyRemarks)" :switch-flg="switchFlgP" />
                </template>
              </el-table-column>
              <el-table-column
                label="更多"
                min-width="4%"
                align="center"
              >
                <template slot-scope="scope">
                  <MoreContent :scope="scope" :is-partner="isPartner" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" min-width="6%">
                <template slot-scope="scope">
                  <span class="promotion" @click="deleteUserCollection(scope.row)">
                    <i class="el-icon-star-on" />
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="我收藏的产品组合" name="second">
          <div class="table-added">
            <div>
              <el-form ref="packageform" :model="packageform" :inline="true">
                <el-row>
                  <el-col :span="24">
                    <el-form-item prop="packageLine">
                      <el-select
                        v-model="packageform.packageLine"
                        filterable
                        clearable
                        placeholder="点选产品线"
                        :loading="loading"
                        value-key="lineId"
                        @change="onPackageLineChange"
                        @clear="clearLine"
                      >
                        <el-option
                          v-for="item in allpackageLines"
                          :key="item.lineId"
                          :label="item.lineName"
                          :value="item"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item>&nbsp;</el-form-item>
                    <el-form-item prop="packageCategories">
                      <el-select
                        v-model="packageform.packageCategories"
                        filterable
                        clearable
                        reserve-keyword
                        placeholder="点选产品大类"
                        :loading="loading"
                        value-key="categoryId"
                        @change="onPackageCategoriesChange"
                        @clear="clearPackageCategories"
                      >
                        <el-option
                          v-for="item in allpackageCategories"
                          :key="item.categoryId"
                          :label="item.categoryName"
                          :value="item"
                        >
                          <span style="font-weight: bold">{{ '[产品大类]：' +item.categoryName }}</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ '[产品线]：'
                            + item.lineName }}
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>&nbsp;</el-form-item>
                    <el-form-item prop="packageSeries">
                      <el-select
                        v-model="packageform.packageSeries"
                        filterable
                        clearable
                        reserve-keyword
                        placeholder="点选产品系列"
                        :loading="loading"
                        value-key="seriesId"
                        @change="seachPackageForm"
                      >
                        <el-option
                          v-for="item in allpackageSeries"
                          :key="item.seriesId"
                          :label="item.seriesName"
                          :value="item"
                        >
                          <span style="font-weight: bold">
                            {{ '[产品系列]：' +item.seriesName }}
                          </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          {{ '[产品大类]：' +item.categoryName }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          {{ '[产品线]：' + item.lineName }}
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>&nbsp;</el-form-item>
                    <el-form-item>&nbsp;</el-form-item>
                    <el-form-item prop="keys">
                      <el-input
                        v-model="packageform.keys"
                        placeholder="通过产品组合名称搜索"
                        @keyup.enter.native="seachPackageForm"
                      />
                    </el-form-item>
                    <el-form-item>&nbsp;</el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="seachPackageForm()">搜索</el-button>
                      <el-button @click="resetPackageForm('packageform')">重置</el-button>
                      <el-button @click="gobackAdded">关闭</el-button>
                    </el-form-item>
                    <el-form-item style="float: right">
                      <el-button type="primary" @click="addPackageToGroupSubItem">添加产品至配置组</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <table class="f-table" width="100%" cellspacing="0" cellpadding="0">
              <thead>
                <tr>
                  <th width="10%" class="td-left">产品组合名称</th>
                  <th width="15%" class="td-left">产品型号</th>
                  <th width="15%" class="td-left">产品描述<button @click="expandDiscribe" style="float: right;background:#FFFFFF;color:#36BADE;border:none;border-radius:5px;height:20px;margin-right: 20px;padding: 0 5px;">全部展开或关闭</button></th>

                  <th width="8%" class="td-center">价格</th>
                  <th width="8%" class="td-center">数量</th>
                  <th width="8%" class="td-center">状态</th>
                  <th width="8%" class="td-center">周期、下单后准备时间</th>
                  <th width="3%" class="td-center">服务分类</th>
                  <th width="15%" class="td-left">
                    特殊说明
                    <button @click="expandDiscribe" style="float: right;background:#FFFFFF;color:#36BADE;border:none;border-radius:5px;height:20px;margin-right: 20px;padding: 0 5px;">
                      全部展开或关闭
                    </button>
                  </th>
                  <th width="5%" class="td-center">更多</th>
                  <th width="5%" class="td-center">操作</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(packageItem,j) in packageInitListVO">
                  <tr :key="j">
                    <td class="td-left td-color-hui">
                      <el-input
                        style="width: 100%"
                        v-model="packageItem.packageName"
                        placeholder="产品组合名称"
                        @change="updatePackageName(packageItem)"
                      />
                    </td>
                    <td colspan="8" class="td-left td-color-hui">
                      <span style="width: 17%">
                        功耗（W）：<span class="f-blue">
                          {{ packageItem.powerDissipation }}
                        </span>
                      </span>&nbsp;
                      <span style="width: 17%">
                        价格（元）：<span class="f-blue">
                          {{ productPriceFormat(null,null,packageItem.productPrice) }}
                        </span>
                      </span>&nbsp;
                      <span style="width: 10%">数量总计：<span class="f-blue">
                        {{ packageItem.quantity }}
                      </span>
                      </span>&nbsp;
                      <span style="width: 10%">套数：
                        <el-input-number
                          v-model="packageItem.purchaseQuantity"
                          controls-position="right"
                          :precision="0"
                          :min="0"
                          label="描述文字"
                          size="mini"
                        />
                      </span>
                    </td>
                    <td class="td-center td-color-hui">
                      <el-button type="text" @click="deletePackage(packageItem)">删除</el-button>
                    </td>
                  </tr>
                  <tr v-for="(item, rowIndex) in packageItem.productInitListVO" :key="rowIndex">
                    <td />
                    <td class="td-left">
                      {{ item.productName }}
                      <span v-if="item.optionalType==1 && item.propertyCode === '1001'">
                        <span class="promotion">
                          <img src="@/assets/selectProduct.png">
                        </span>
                      </span>
                      <span v-if="item.standardFlag==1">
                        <span class="promotion">
                          <img src="@/assets/newImport.png">
                        </span>
                      </span>
                      <span v-if="item.isDiscount && !isPartner">
                        <span class="promotion">
                          <img src="@/assets/promotion-new.png">
                        </span>
                      </span>
                      <span v-if="isControlled(item)">
                        <span class="promotion">
                          <img src="@/assets/controlled-new.png">
                        </span>
                      </span>
                      <span v-if="isNewProduct(item)">
                        <span class="promotion">
                          <img src="@/assets/newproduct-new.png">
                        </span>
                      </span>
                      <span v-if="item.industryIsEnabled==false" class="promotion">
                        <img src="@/assets/shelves-new.png">
                      </span>
                      <span v-if="item.quotation==1" class="promotion2">
                        <img src="@/assets/fuwushang-new.png">
                      </span>
                      <span v-if="item.quotation==2 && getStore('industryFlg') == 1" class="promotion2">
                        <img src="@/assets/fuwushang-new.png">
                      </span>
                    </td>
                    <td class="td-left">
                      <long-text :text="item.productDesc" :switch-flg="switchFlgP" />
                    </td>
                    <td class="td-center">{{ item.productPrice }}</td>
                    <td class="td-center">
                      <el-input-number
                        v-model="item.quantity"
                        controls-position="right"
                        :precision="0"
                        :min="0"
                        label="描述文字"
                        size="mini"
                        @change="updatePackage(item)"
                      />
                    </td>
                    <td class="td-center">
                      <ProductStatusFomation :scope="item" />
                    </td>
                    <td class="td-center">
                      <ProductTypeFormation :scope="item" />
                    </td>
                    <td class="td-center">{{ item.productPscType }}</td>
                    <td class="td-left">
                      <long-text :text="notesTextFormat(item.notes,item.supplyRemarks)" :switch-flg="switchFlgP" />
                    </td>
                    <td class="td-center">
                      <span v-show="showRemark(item)">
                        <el-popover trigger="click" placement="top">
                          <div v-if="showDiscount(item)">
                            <p>
                              <span>促销价格：{{ item.promotionPrice }}元</span>
                            </p>
                            <p>
                              <span
                                v-if="item.discountEndDateTime == null && item.discountStartDateTime == null"
                              >促销时间：无</span>
                              <span
                                v-else
                              >促销时间：{{ item.discountStartDateTime }}&nbsp;至&nbsp;{{ item.discountEndDateTime }}
                              </span>
                            </p>
                          </div>
                          <div v-if="(item.isSpdc == 1 && getStore('partnerFlg') == 'Partner' && getStore('partnerAuth') == '1' || getStore('partnerFlg') != 'Partner')">
                            <p>
                              <span>服务商价格：{{ item.spdcPrice }}元</span>
                            </p>
                            <p v-if="item.isSpdcDiscount != null && item.isSpdcDiscount == 1">
                              <span
                                v-if="item.spdcDiscountStartTime == null && item.spdcDiscountEndTime == null"
                              >促销时间：无</span>
                              <span
                                v-else
                              >促销时间：{{ item.spdcDiscountStartTime }}&nbsp;至&nbsp;{{ item.spdcDiscountEndTime }}</span>
                            </p>
                          </div>
                          <p v-html="item.remarks " />

                          <div slot="reference" class="name-wrapper">
                            <el-tag size="medium">
                              <i>
                                <img src="../../assets/remark.png">
                              </i>
                            </el-tag>
                          </div>
                        </el-popover>
                      </span>
                    </td>
                    <td class="td-center">
                      <el-button type="text" @click="deletePackage(item)">删除</el-button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </el-tab-pane>
      </el-tabs>

      <div>
        <el-dialog title="产品提示信息" :visible.sync="dialogNoticeVisible" append-to-body>
          <div style="color: red" v-if="noticeText !=null && noticeText !=''">
            您添加的产品中有产品发生变更请重新收藏：{{ noticeText }}
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelWind">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import eventBus from '@/utils/eventBus';
import { CommonAddition } from '@/utils/addproductMinxin';
import { PackagePage } from '@/utils/packageMinxin';
import { setStore, getStore, notesTextFormat } from '@/utils/mUtils';
import ProductStatusFomation from '../components/ProductStatusFomation';
import ProductTypeFormation from '../components/ProductTypeFormation';
import api from '@/api';
export default {
  name: 'UserCollection',
  components: { ProductTypeFormation, ProductStatusFomation },
  mixins: [CommonAddition, PackagePage],
  props: {
    configurationGroup: {
      type: Object,
      default: ()=>{}
    }
  },
  data () {
    return {
      activeName: 'first'
    };
  },
  methods: {
    getStore,
    notesTextFormat,
    deleteUserCollection (row) {
      this.$confirm('确认取消收藏的产品么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          params: {
            productCode: row.productCode,
            seriesId: row.seriesId
          }
        };
        api.deleteUserCollection(param).then((response) => {
          let jsonData = response.data;
          if (jsonData.status === '200') {
            this.$notify({
              type: 'success',
              message: '取消收藏成功!'
            });
            this.seachForm();
          }
        }, (err) => {
          this.$notify.error('取消收藏失败，请联系管理员！');
        });
      });
    }

  }
};

</script>

<style lang="scss">

  @import "../../styles/product-common.css";
  @import "../../styles/product-table.css";

  user-collection{

  }

  .user-collection .el-table .cell{
    white-space: normal;
  }

  .clearfloat{
    clear: both;
  }

  .user-collection .el-row{
    margin-bottom: 0px;
  }

  .user-collection .table{
    margin-bottom: 0;
  }
  .user-collection .head-section{
    height:  80px;
  }

  .clear{
    clear:both;
  }

  .user-collection .el-form-item{
    float: left;
    margin-right: 0;
    margin-bottom: 0;
  }

  .user-collection .table .el-table .cell{
    white-space:normal;
  }

  .user-collection .el-dialog__body{
    padding: 10px 10px;
  }

  .user-collection .dialog-footer{
    text-align: center;
  }

  .el-popover{
    width: 300px;
  }

  .user-collection   .promotion{
    font-size: 20px;
    color:#37BADE;
  }
  .el-col {
    border-radius: 4px;
  }

  .user-collection .el-dialog__header{
    height: 3px;
    padding: 0px;
  }

  .el-tabs__item{
    background: #37BADE;
    border: 1px solid #37BADE;
    color: white;
    height: 2rem;
    line-height: 2rem;
    &.is-active{
      background: white;
      border: 1px solid #37BADE;
      color: black;
      height: 2rem;
      line-height: 2rem;
    }
  }

  @media screen and (max-width: 1366px) {

    .user-collection table *{
      margin: 0;
      padding: 0;
    }

    .user-collection .table{
      margin-bottom: 0;
    }

  }

</style>
